module.exports = {
      id: "icon-a-edit-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "../resources/views/web/layout/partials/svg-icons.blade.php#icon-a-edit",
      toString: function () {
        return this.url;
      }
    }